<router-outlet></router-outlet>
<spinner *ngIf="showSpinner"></spinner>